import {Alert, Box, Button, Dialog, DialogContent, Typography} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";

export const ProductError = ({ open }) => {
  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Typography
            variant="h5"
            fontWeight={"700"}
            textAlign={"center"}
            sx={{ mb: 1.5 }}
          >
            خطا در دریافت محصول!
          </Typography>
          <Typography
            textAlign={"center"}
            mt={3}
            sx={{ mb: 6, color: "text.secondary" }}
          >
            خطایی در دریافت محصول مورد نظر شما به وجود آمده است لطفا مجددا تلاش
            فرمایید.
          </Typography>
          <Box textAlign={"center"}>
            <Button
              onClick={() => {
                window.location.reload();
              }}
              variant="contained"
            >
              تلاش مجدد
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};
